import { render, staticRenderFns } from "./edition-public-row.vue?vue&type=template&id=362ab3e4&"
import script from "./edition-public-row.vue?vue&type=script&lang=ts&"
export * from "./edition-public-row.vue?vue&type=script&lang=ts&"
import style0 from "./edition-public-row.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports